import { all, takeLatest, call, put } from "redux-saga/effects";
import { setDocumentsList, setApprovalDocumentsLoading } from "./actions";
import { approvalDocumentsService } from "../../../service/approvalDocuments.service";

function* fetchApprovalDocumentsList({ payload }) {
  try {
    const { eventId, params = {}, callbackSuccess, callbackError } = payload;

    if (eventId) {
      yield put(setApprovalDocumentsLoading(true));

      const response = yield call(approvalDocumentsService, eventId, params);

      if (response.status === 200) {
        const documentsList =
          response.data?.data || response.data?.output || response.data || [];

        yield put(setDocumentsList(documentsList));

        if (callbackSuccess) {
          callbackSuccess(documentsList);
        }
      } else {
        yield put(setDocumentsList([]));
        if (callbackError) callbackError("Erro ao buscar documentos");
      }
    } else {
      yield put(setDocumentsList([]));
    }
  } catch (error) {
    yield put(setDocumentsList([]));

    const errorCode = error.response?.data?.code || error.message;
    if (payload.callbackError) payload.callbackError(errorCode);
  } finally {
    yield put(setApprovalDocumentsLoading(false));
  }
}

export default all([
  takeLatest("FETCH_DOCUMENTS_LIST", fetchApprovalDocumentsList),
]);
